var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.923096 20.4295C0.923096 19.5523 1.63166 18.8413 2.50551 18.8413H21.4945C22.3684 18.8413 23.0769 19.5523 23.0769 20.4295V21.4883C23.0769 22.3654 22.3684 23.0765 21.4945 23.0765H2.50551C1.63166 23.0765 0.923096 22.3654 0.923096 21.4883V20.4295ZM2.50551 19.9001C2.21429 19.9001 1.97798 20.1371 1.97798 20.4295V21.4883C1.97798 21.7806 2.21429 22.0178 2.50551 22.0178H21.4945C21.7858 22.0178 22.0221 21.7806 22.0221 21.4883V20.4295C22.0221 20.1371 21.7858 19.9001 21.4945 19.9001H2.50551Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2749 7.72381C17.2749 7.43133 17.511 7.19434 17.8023 7.19434H20.9671C21.2585 7.19434 21.4946 7.43133 21.4946 7.72381V19.3706C21.4946 19.663 21.2585 19.9 20.9671 19.9H17.8023C17.511 19.9 17.2749 19.663 17.2749 19.3706V7.72381ZM18.3298 8.2531V18.8416H20.4397V8.2531H18.3298Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.89001 7.72381C9.89001 7.43133 10.1263 7.19434 10.4175 7.19434H13.5824C13.8736 7.19434 14.1099 7.43133 14.1099 7.72381V19.3706C14.1099 19.663 13.8736 19.9 13.5824 19.9H10.4175C10.1263 19.9 9.89001 19.663 9.89001 19.3706V7.72381ZM10.9451 8.2531V18.8416H13.0549V8.2531H10.9451Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50549 7.72381C2.50549 7.43133 2.74162 7.19434 3.03303 7.19434H6.19786C6.48909 7.19434 6.72521 7.43133 6.72521 7.72381V19.3706C6.72521 19.663 6.48909 19.9 6.19786 19.9H3.03303C2.74162 19.9 2.50549 19.663 2.50549 19.3706V7.72381ZM3.56038 8.2531V18.8416H5.67033V8.2531H3.56038Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4123 1.03652C11.7895 0.884963 12.2105 0.884963 12.5878 1.03652L22.0823 4.84828C22.6831 5.08953 23.0769 5.67343 23.0769 6.32289V6.66482C23.0769 7.54207 22.3684 8.25305 21.4945 8.25305H2.50551C1.63166 8.25305 0.923096 7.54207 0.923096 6.66482V6.32289C0.923096 5.67343 1.31711 5.08951 1.91776 4.84828L11.4123 1.03652ZM12.1959 2.01959C12.0701 1.96907 11.9299 1.96907 11.8042 2.01959L2.30965 5.83135C2.10938 5.91182 1.97798 6.10646 1.97798 6.32289V6.66482C1.97798 6.95729 2.21429 7.19429 2.50551 7.19429H21.4945C21.7858 7.19429 22.0221 6.95729 22.0221 6.66482V6.32289C22.0221 6.10646 21.8907 5.91182 21.6904 5.83135L12.1959 2.01959Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanking);
export default __webpack_public_path__ + "static/media/Banking.debe2aff8a4db07ebfc3cfa6f1c04b6f.svg";
export { ForwardRef as ReactComponent };